import { User } from '@hefe/models';
import { Button, List, Row, Space } from 'antd';
import { useAppDispatch } from '../../../../store/store';
import { t } from '@hefe/i18n';
import NotificationsListItemComponent from '../notifications-list-item/notifications-list-item.component';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { fetchUserNotifications, userNotificationsSelector } from '@hefe/store';

interface NotificationsListComponentProps {
  user: User;
}

export default function NotificationsListComponent(
  props: NotificationsListComponentProps
) {
  const { user } = props;

  const dispatch = useAppDispatch();
  const notifications = useSelector(userNotificationsSelector);

  const [loadingNotifications, setLoadingNotifications] = useState(false);

  const loadNotifications = () => {
    const currentPage =
      notifications.current_page === -1 ? 1 : notifications.current_page + 1;
    setLoadingNotifications(true);
    dispatch(fetchUserNotifications(currentPage))
      .unwrap()
      .catch(() => null)
      .finally(() => setLoadingNotifications(false));
  };

  const data = () => {
    if (notifications.current_page === -1) {
      return user.notifications.last5;
    }

    return notifications.data;
  };

  return (
    <List
      dataSource={data()}
      renderItem={(item) => (
        <NotificationsListItemComponent notification={item} />
      )}
      footer={
        <Row justify="center">
          {(notifications.current_page === -1 ||
            notifications.next_page_url) && (
            <Button
              loading={loadingNotifications}
              onClick={() => loadNotifications()}
            >
              {t('load_more.notifications')}...
            </Button>
          )}
        </Row>
      }
    />
  );
}
